<template>
  <div class="h-full">
    <el-row class="h-full w-full">
      <el-col :span="24" class="h-full">
        <div
          ref="ysplayer"
          :class="[className, 'w-full', 'h-full', 'flex', 'justify-between', 'flex-wrap']"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* 宇视——视频播放器 */

import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
/* eslint-disable */
export default {
  props: {
    // 摄像头编码
    code: {
      type: Array,
      defalut: [],
    },
    // 获取协议实例需要用到【pIid】,返回的内容包含有ip、端口、用户名、密码
    pIid: {
      type: String,
      defalut: '',
    },
    // 针对实时监控时，在同一个窗口播放不同摄像头监控的标记
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFirst: true,
      className: 'ysplayer',
      streamType: 2, // 码流类型; 1 = 主码流；2 = 辅码流
      iframeObjIdArr: [],
      ipAddress: '',
      username: '',
      password: '',
      port: '',
    }
  },
  async mounted() {
    console.log(this.code, 'code')
    this.getConfig()
  },
  methods: {
    // 登录
    async login() {
      const _this = this
      const apiUrl = `http://${this.ipAddress}:${this.port}/VIID/login/v2`
      const requestOption = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      }
      fetch(apiUrl, requestOption)
        .then((response) => {
          // console.log('第一次调登录接口的请求响应状态信息', response)
          if (response.status === 200) {
            return response.json()
          } else {
            throw new Error('网络请求失败')
          }
        })
        .then((res) => {
          // console.log('第一次调登录接口的响应结果', res)
          const accessCode = res.AccessCode
          const md2 = forge.md.md5.create() // md5
          const base64Username = window.btoa(this.username)
          const loginSignatureTemp = base64Username + accessCode + this.password
          md2.update(loginSignatureTemp) // md5
          const loginSignature = md2.digest().toHex() // md5
          // console.log('加密后的loginSignatureTemp:', loginSignature)
          const data = {
            UserName: this.username,
            AccessCode: accessCode,
            LoginSignature: loginSignature,
          }
          const requestOpion2 = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify(data),
          }
          // console.log('第二次调用登录接口传的参数:', data)
          fetch(apiUrl, requestOpion2)
            .then((response) => {
              // console.log('第二次调登录接口的请求响应状态信息', response)
              if (response.status === 200) {
                return response.json()
              } else {
                throw new Error('网络请求失败')
              }
            })
            .then((r) => {
              // console.log('第二次调用登录接口的响应结果', r)
              const loginResult = r.ErrCode
              switch (
                loginResult // 判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
              ) {
                case 50004:
                  // console.log('密码错误')
                  break
                case 12351:
                  // console.log('用户不存在')
                  break
                case undefined:
                  window.playerToken = r.AccessToken
                  // console.log(loginResult, '登录成功11')
                  // 在使用https 的时候设置为https 代理端口号
                  const ishttps = document.location.protocol === 'https:'
                  if (ishttps) {
                    imosSdk.setLinkPort('7077')
                  }
                  const vmip = _this.ipAddress
                  imosSdk
                    .init(vmip, window.playerToken, 1, '/unv/imosSdk.html')
                    .then(() => {})
                    .catch((err) => {
                      // console.log('调用失败')
                      // console.log(err)
                    })
                  break
                default:
              }
              console.log(this.code)
              _.forEach(this.code, (item, index) => {
                console.log(item, index, '循环code')
                _this.creatWindow(item, index)
              })
              this.isFirst = false
            })
            .catch((e) => {
              // console.log('服务器连接异常')
              // console.log(e)
            })
        })
        .catch((error) => {
          // console.log('服务器连接异常123')
          // console.log(error)
        })
    },
    async getConfig() {
      const [err, res] = await iotDeviceProtocolInstanceApi.get(this.pIid)
      if (!err && res?.jsonContent) {
        console.log(res, 'res')
        const parsedInfo = JSON.parse(res.jsonContent)
        this.ipAddress = parsedInfo.IP
        this.username = parsedInfo.UserName
        this.password = parsedInfo.PassWord
        this.port = parsedInfo.Port
        // this.ipAddress = 'imos.wiz.top'
        // this.username = 'loadmin'
        // this.password = '2c57282991e301c1c542f67396fed9d5'
        // this.port = '8088'
        this.login()
      } else {
        this.ipAddress = ''
        this.username = ''
        this.password = ''
        this.port = ''
      }
    },
    creatWindow(item, index) {
      console.log(window.playerToken, item, index, '进入了createWindow')
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      const iframeObj = imosSdk.createPanelWindow()
      // 如果窗格创建已经到达上限
      if (iframeObj === null) {
        return
      }
      console.log(iframeObj, 'iframeObj')
      console.log('creatWindow创建的窗格id为：', iframeObj.id)
      this.iframeObjIdArr.push(iframeObj.id)
      this.createSpeDiv(iframeObj, item)
    },
    createSpeDiv(iframeObj, code) {
      const videoDom = this.$refs.ysplayer
      // 如果传进来的序号和之前的一样，说明没有切换窗口，把原有窗口置空
      let divDom = document.createElement('div')
      divDom.style = 'height: 50%;width: 50%;'
      divDom.appendChild(iframeObj)
      videoDom.appendChild(divDom)
      divDom = null
      this.playLive(iframeObj.id, code)
    },
    // 实时播放
    playLive(id, code) {
      if (!window.playerToken) {
        // console.log('请先登录')
        return
      }
      // console.log('this.code', this.code)
      imosSdk.playLive(
        id, // 播放窗格的Id
        code, // 摄像头编码
        code, // 需要显示的标题名称
        (e) => {
          // console.log('播放实时视频的回调结果', e)
        },
        this.streamType
      )
    },
  },
  watch: {
    code(val) {
      const _this = this
      if (this.isFirst) {
        return
      }
      console.log(val, '捕捉到了新的code')
      _.forEach(val, (item, index) => {
        console.log(item, '捕捉到了新的code后执行第一个item')
        this.playLive(_this.iframeObjIdArr[index], item)
      })
    },
  },
}
</script>

<style scope lang="scss">
.imosSdk-video {
  height: 100% !important;
  width: 100% !important;
  border-width: 0 !important;
}
.btnCont {
  // width: 250px;
  // display: flex;
  align-items: center;
}
.controlImg {
  width: 30px;
  &_up {
    transform: rotate(90deg);
  }
  &_right {
    margin-left: 30px;
    transform: rotate(180deg);
  }
  &_down {
    transform: rotate(-90deg);
  }
}
.tc {
  text-align: center;
  text-align: -webkit-center;
}
</style>
